import { EventEmail } from '@/domain/swing/event/email';

export default function EventEmailPage() {
  return (
    <EventEmail />
  );
}